export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">移动端快捷入口</h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                将91樱花添加到手机桌面，像使用原生App一样快速访问动漫内容。
              </p>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                支持Safari（iOS）和Chrome（Android）的"添加到主屏幕"功能，无需下载安装，不占存储空间，一键直达追番世界。添加后还能接收最新地址更新通知，再也不用担心找不到入口。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                  <i className="ri-apple-line text-lg text-foreground-600"></i>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">iOS Safari 支持</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                  <i className="ri-android-line text-lg text-foreground-600"></i>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">Android Chrome 支持</span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-0">
              <div className="w-48 h-80 md:w-56 md:h-96 bg-background-200 rounded-2xl overflow-hidden border-4 border-background-300 shadow-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20an%20anime%20streaming%20app%20interface%20with%20cherry%20blossom%20pink%20theme%2C%20anime%20thumbnails%20grid%20layout%2C%20clean%20modern%20UI%2C%20Japanese%20aesthetic%2C%20soft%20warm%20colors%2C%20minimalist%20design%2C%20app%20store%20style%20presentation&width=600&height=960&seq=91sakura-app-mock&orientation=portrait"
                  alt="91樱花移动端入口展示"
                  className="w-full h-full object-cover object-top"
                  title="91樱花移动端快捷入口"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}